
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehiclefleetapp",
      function () {
        return require("private-next-pages/vehiclefleetapp/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehiclefleetapp"])
      });
    }
  